import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  managerState: {
    managers: [],
    managersLoading: false,
    managerDataFetchedAt: null,
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setManagers: {
      reducer(state, action) {
        return {
          ...state,
          managerState: {
            ...state.managerState,
            managers: action.payload,
          },
        };
      },
    },
    setManagersLoading: {
      reducer(state, action) {
        return {
          ...state,
          managerState: {
            ...state.managerState,
            managersLoading: action.payload,
          },
        };
      },
    },
    setManagerDataFetchedAt: {
      reducer(state, action) {
        return {
          ...state,
          managerState: {
            ...state.managerState,
            managerDataFetchedAt: action.payload,
          },
        };
      },
    },
  },
});

export const { setManagers, setManagersLoading, setManagerDataFetchedAt } =
  appSlice.actions;

export default appSlice.reducer;
